import Details from "./01Details";
import Mortgage from "./02Mortgage";
import WhatWillHappen from "./03WhatWillHappen";

export const formSteps = {
  1: Details,
  2: Mortgage,
  3: WhatWillHappen,
};
